import { publish, subscribe } from '@wh/message-bus';
import { StateType } from '@central-products/interface-session-service';
import { commandSaferGamblingModalsStart } from './events';

export default (function () {
  subscribe({
    topic: 'wh.common.event.sessionService.state.changed',
    callback: function callback(_ref) {
      var state = _ref.data.state;

      if (state === StateType.SESSION_EXISTS) {
        publish(commandSaferGamblingModalsStart);
      }
    }
  });
});